import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//     authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_IN_SENDER_ID,
//     appId: process.env.REACT_APP_FIREBASE_APP_ID,
//     measurementId: process.env.REACT_APP_FIREBASE_MEASUREEMENT_ID,
// };

const firebaseConfig = {
    apiKey: "AIzaSyDpzptVdpasu24aCKqqSfAWyGDgIXN8-qE",
    authDomain: "devices-front.firebaseapp.com",
    projectId: "devices-front",
    storageBucket: "devices-front.appspot.com",
    messagingSenderId: "792539550313",
    appId: "1:792539550313:web:804f4c3713a1dd3cab08f8",
    measurementId: "G-H1CM16H9K4"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;